import { composeIO } from 'react-compose-io'
import { regularizacaoPedidosInformacoesIO } from './RegularizacaoPedidosInformacoes.IO'
import { RegularizacaoPedidosInformacoesView } from './RegularizacaoPedidosInformacoesView'

export const RegularizacaoPedidosInformacoes = composeIO(RegularizacaoPedidosInformacoesView, regularizacaoPedidosInformacoesIO)
